import { send } from "@utils/fetch";
import { captureException } from "@utils/error";

/**
 * Send UserData, EventData or both to Braze.
 */
function saveToBraze({
  user = null,
  event = null,
}: {
  user?: JsonObject;
  event?: { event_name: string; event_data?: JsonObject };
}): Promise<void> {
  if (!user && !event) {
    captureException(new Error("saveToBraze: No data to send to Braze"));
    return Promise.resolve();
  }

  const payload: JsonObject = {
    user,
    event,
  };

  return send("POST", "/userdata/api/v4/user/braze/save/", payload).catch(
    (err) => {
      captureException(err);
    }
  );
}

export default saveToBraze;
